import React from 'react';
import './index.css';
import Tickets from './tickets';
import Propuestas from './propuestas';
import ImageSlider from '../../components/imageslider';
import bus from 'assets/images/movimiento-bus.png';

export default function Movimiento() {
  return (
    <div id="movimiento">
      <div className="wrapper">
        <div className='movimiento-intro'>
          <div className="logo">
            <h3>Bienvenidos a Incluir en movimiento</h3>
          </div>
          <figure>
            <img src={bus} alt="Imagen de bus" />
          </figure>
          <figcaption>
            <p>El ciclo itinerante de educación financiera que llega a distintas localidades de la Provincia con propuestas educativas y de entretenimiento para todas las edades.</p>
          </figcaption>
        </div>
        <Tickets />
        <Propuestas />
        <h4>Reviví en imágenes todas las jornadas</h4>
        <ImageSlider galeria="movimiento" />
      </div>
    </div>
  );
}